export const SEND_CONTACT_EMAIL = "contact_email";
export const GET_CSRF_TOKEN = "get_csrf";
export const GET_SERVER_DATE_TIME = "get_server_current_date_time";
